import { ProjectStatus } from '../../../models';

export const projectStatusTypeMapper = (status: ProjectStatus) => {
  switch (status) {
    case ProjectStatus.PENDING_ACTIVATION:
      return 'Pending Activation';
    case ProjectStatus.ACTIVE:
      return 'Activated';
    case ProjectStatus.CANCELLED:
      return 'Cancelled';
    case ProjectStatus.ENDED:
      return 'ended';
    case ProjectStatus.PAUSED:
      return 'Paused';
  }
};
